import url from "url";
import {updateQueryStringParameter} from "./formatters";

const CLOUDFRONT_URL = process.env.VUE_APP_CLOUDFRONT_URL;


export const buildAudioAttachmentURL = () =>  url.resolve(CLOUDFRONT_URL, 'web_static/music.png');

export const buildAwardURL = (awardID, extension) => {
  return url.resolve(
    CLOUDFRONT_URL,
    `/awards/${awardID}.${extension}?`
  );
};
export const buildAttachmentURL = (postID, attachmentID, extension, hash) => {
  return url.resolve(
    CLOUDFRONT_URL,
    `/posts/${postID}/${attachmentID}.${extension}?h=${hash}`
  );
};

export const buildAttachmentHLSpath = (postID, attachmentID, extension, hash, hls_path) => {
  return url.resolve(
    CLOUDFRONT_URL,
    `/posts/${postID}/${attachmentID}.${extension}${hls_path}?h=${hash}`
  );
};

export const buildThumbURL = (postID, attachmentID, extension, hash) => {
  return url.resolve(
    CLOUDFRONT_URL,
    `posts/${postID}/thumbs/${attachmentID}.${extension}?h=${hash}`
  );
};

export const buildSpaceLogoURL = (
  spaceID,
  logoID,
  logoImgType,
  logoLastChanged=null
) => {
  if (logoID == -1) {
    let key = logoLastChanged + "." + logoImgType;
    return url.resolve(CLOUDFRONT_URL, `spaces/${spaceID}/logos/${key}`);
  } else{
    return url.resolve(CLOUDFRONT_URL, `predefined_logos/${logoID}.${logoImgType}`);
  }
};

export const buildYoutubeThumbURL = (link) => {
  var match = link.match(
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  );
  var videoID = match && match[7].length == 11 ? match[7] : false;
  return videoID ? `http://img.youtube.com/vi/${videoID}/0.jpg` : "";
};

export const reduceAssetDimensions = (url, w=850, h=850) => {
  return updateQueryStringParameter(url, 'd', `${w}x${h}`)
}
